import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-two',
  templateUrl: './breadcrumb-two.component.html',
  styleUrls: ['./breadcrumb-two.component.scss']
})
export class BreadcrumbTwoComponent implements OnInit {

  @Input() historyItems = [];

  constructor() { }

  ngOnInit(): void {
  }

}
